'use strict';

export default function () {
  return function filter(extraParams) {
    const url = new URL(window.location.href)
    for (const key in extraParams) {
      url.searchParams.set(key, extraParams[key]);
    }
    return url.toString();
  }
}
